import {Injectable} from '@angular/core';
import {ServiceModule} from '../../../service.module';
import {AutomationModel} from "../../../../core/models/misc/automation.model";
import {HttpService} from "../http-service/http.service";
import {Observable} from "rxjs";

@Injectable({providedIn: ServiceModule})
export class AutomationService {
    constructor(private httpService: HttpService<any>) {
    }

    runAutomation(model: AutomationModel, query = ''): Observable<any> {
        return this.httpService.post(`/api/automation${query}`, model);
    }

    getAutomations(): Observable<any> {
        return this.httpService.get('/api/cloudAutomationDesigner');
    }

    getAutomationSolution(path: string, name: string): Observable<any> {
        return this.httpService.get(`/api/resources/cloud-automation.resource.api.sap/v1/AutomationSolution${path}/${name}`);
    }

    getRequests(path: string, name: string, itemsPerPage: number, currentPage: number, start: string, end: string, status: string, requestsSortAsc: boolean, query: string, solutionType: string, isChina = false): Observable<any> {
        let url = `/api/cloudAutomationDesigner${path}/${name}/requests?size=${itemsPerPage}&page=${currentPage}&solutionTypes=${solutionType}`;

        if (start !== null) {
            url += `&fromCreatedDate=${start}`;
        }

        if (end !== null) {
            url += `&toCreatedDate=${end}`;
        }

        if (status !== null) {
            url += `&overallStatus=${status}`;
        }

        if (requestsSortAsc) {
            url += `&direction=ASC`;
        } else {
            url += `&direction=DESC`;
        }

        if (query.length > 0) {
            url += query;
        }

        if (isChina) {
            url += `&isChina=true`;
        }

        return this.httpService.get(url);
    }

    getRequest(path: string, name: string, currentRequestGUID: string, isChina = false) {
        let url = `/api/cloudAutomationDesigner${path}/${name}/requests/${currentRequestGUID}`;
        if (isChina) {
            url += `?isChina=true`;
        }
        return this.httpService.get(url);
    }

    sortSolutionsByName(solutions: any[]) {
        solutions.sort((a: any, b: any) => {
            const nameA = a?.resource?.spec?.solution?.cloudAutomationSolution?.name?.charAt(0) || '';
            const nameB = b?.resource?.spec?.solution?.cloudAutomationSolution?.name?.charAt(0) || '';

            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }

}
